<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <el-steps :active="integrationWizardIndex" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>   
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="1">
              <span class="cnct-wef-header" style="margin-bottom: 22px"
                >How to connect to WEF(Windows Event Forwarding)</span
              >
              <p class="top-header">
                This wizard walks you through the simple steps to connect Confluera CxDR to your WEF account. If you
                have multiple WEF accounts, simply run this wizard to configure each account.
              </p>

              <el-row type="flex" :gutter="24" style="margin: -32px 0px 0px;">
                <el-col :span="4" class="integration-logo-container">
                  <el-card shadow="hover" class="integration-logo-card">
                    <img class="wef-logo" src="/static/images/logos/wef-color.svg" alt="wef logo"/>
                  </el-card>
                </el-col>
                <el-col :span="20" class="connect-wef">
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 1</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Designate a host that can act as Windows event collector (the
                        <br />Collector host)
                        <a @click="loadDocumentation('page-partner-signals-wef')">Learn More</a>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 2</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Push a group policy update for Window Event Forwarding
                        <br />Option 1 - Run Confluera script
                        <a @click="loadDocumentation('page-partner-signals-wef')">Download</a>
                        <br />Option 2 - Configure manually
                        <a @click="loadDocumentation('page-partner-signals-wef')">Learn More</a>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 3</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Install and run Confluera Sensor on Collector host
                        <a @click="loadDocumentation('page-partner-signals-wef')">Learn More</a>
                        <br />Download Confluera Sensor package
                        <a @click="loadDocumentation('page-partner-signals-wef')">Download</a>
                        <br />Run the Confluera Sensor by following instructions
                        <a @click="loadDocumentation('page-partner-signals-wef')">Learn More</a>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 4</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        You are all set! Windows servers monitored via WEF will now start
                        <br />showing up in the VM Assets view.
                      </el-col>
                    </el-row>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'WefIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {}
  },
  methods: {},
  created () {},
  computed: {},
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}

.initiated {
  h4 {
    margin-bottom: 40px;
  }

  p {
    text-align: center;
    width: 60%;
    margin: auto;
    display: block;
  }

  >>> .el-button {
    margin: auto;
  }

  >>> .el-icon-loading,
  .material-icons {
    font-size: 2em;
  }

  .center-text.error-icon {
    margin: auto;
    font-size: 2em;
  }
}

>>> .el-carousel--horizontal {
  overflow-x: hidden;
  width: 110%;
}

>>> .el-step__head.is-success {
  color: #1a90fa;
}

>>> .el-step__head {
  fill: #1a90fa;
  border-color: #1a90fa;
}

>>> .el-step__line {
  background-color: #1a90fa;
}

>>> .el-step__icon-inner {
  color: #1a90fa;
}

.el-form-item {
  margin-bottom: 0px;
}

.top-header {
  height: 94px;
  width: 834px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.17px;
  line-height: 22px;
}

/* .top-header-title {
  font-weight: 500px;
  font-size: 24px;
  margin-bottom: 22px;
} */

.conf-block {
  display: inline-block;
  width: 34.86%;
  height: 27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 50px;
}

.integration-settings {
  .el-steps {
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 1px #f0f0f0;
  }

  >>> .el-carousel {
    margin: 10px 0 30px 0;

    .el-carousel__container {
      height: 800px;
    }
  }
}

.cnct-wef-header {
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500px;
  font-size: 24px;
}

.el-step-fixes {
  width: 20%;
  padding-left: 0px;
  border: none;
}

.connect-wef {
  margin-left: 12px;
  width: 379px;
  height: 700px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.wef-logo {
  margin-top: 28px;
  width: 70px;
  height: 70px;
  margin-left: 28px;
}

>>> .el-carousel__item {
  height: 1000px;
}

>>> .el-col-23 {
  width: 121%;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/WefIntegrationWorkflow.vue